import { sourceIconMapping } from '@components/common/sourceIcons'

import type { FileTypeInput, UserFileType } from '../types'

export const getFileTypeName = (fileType: FileTypeInput): string => {
  const name =
    typeof fileType === 'string'
      ? fileType
      : fileType.name ?? fileType.key ?? fileType.extension ?? ''

  if (!name) return ''
  return name.startsWith('.') ? name.toLowerCase() : `.${name.toLowerCase()}`
}

export const getFileTypeIcon = (fileType: FileTypeInput): string | null => {
  const name = getFileTypeName(fileType)
  if (!name) return null
  return sourceIconMapping[name.replace('.', '')] ?? null
}

export const getFileTypeKey = (fileType: FileTypeInput): string => {
  const id = typeof fileType === 'string' ? '' : String(fileType.id ?? '')
  return `${id}-${getFileTypeName(fileType)}`
}

export const normalizeUserFileTypes = (
  fileTypes: FileTypeInput[]
): UserFileType[] => {
  const seen = new Set<string>()

  return fileTypes.reduce<UserFileType[]>((items, fileType) => {
    const name = getFileTypeName(fileType)
    if (!name || !getFileTypeIcon(fileType) || seen.has(name)) return items

    seen.add(name)
    return [
      ...items,
      {
        id: typeof fileType === 'string' ? '' : String(fileType.id ?? ''),
        name,
      },
    ]
  }, [])
}
